<template>
  <el-dialog
    :visible.sync="config.dialogVisible"
    class="dialog-container"
    :width="'470px'"
    :before-close="handleClose">
    <!-- v-loading="loading" -->
        <div slot="title">
            <div>编辑应用</div>
        </div>
        <!-- 重新选择文件 -->
        <div class="app-info-item reselect-file" v-if="!isEditApp">
            <div class="item-title">选择文件：</div>
            <div class="item-content">
                <cloud-upload class="local-add" ref="appFile" :config="appUploadConfig" @beforeUpload="beforeApkFileSelected">
                    <div class="local-add-slot">
                        <div>
                            <img class="icon-img" src="/Account/images/setting/navigation/device-management/icon_file_upload.png">
                        </div>
                        <div>重新选择文件</div>
                    </div>
                </cloud-upload>
            </div>
        </div>
        <!-- 资源图片 -->
        <div class="app-info-item reselect-appicon">
            <div v-if="!isEditApp">
                <div class="item-title">资源图片：</div>
                <div class="item-content">
                    <cloud-upload v-if="!isEditApp" class="local-add app-icon" ref="appIcon" :config="appIconUploadConfig" @beforeUpload="beforeApkIconSelected">
                        <div class="app-icon-wrap"  v-if="this.appIcon">
                            <img :src="this.appIcon" alt="重新上传资源图片">
                            <div class="app-icon-refresh"></div>
                        </div>
                        <span v-else>重新上传资源图片</span>
                    </cloud-upload>
                </div>
            </div>
            <!-- 二次编辑应用信息时只显示头像 -->
            <div v-if="isEditApp" class="edit-status">
                <div class="edit-title">资源图片：</div>
                <div class="app-icon"> 
                    <img :src="this.appIcon" alt="">
                </div>
            </div>
        </div>
        <!-- 资源名称 -->
        <div class="app-info-item">
            <div class="item-title">资源名称：</div>
            <div class="item-content">
                <el-input v-model="resName" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <!-- 文件名称 -->
        <div class="app-info-item">
            <div class="item-title">文件名称：</div>
            <div class="item-content">
                <el-input v-model="appName" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <!-- 版本软件 -->
        <div class="app-info-item">
            <div class="item-title">软件版本：</div>
            <div class="item-content">
                <el-input v-model="appVersion" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <!-- 运行环境 -->
        <div class="app-info-item">
            <div class="item-title">运行环境：</div>
            <div class="item-content">
                <el-input v-model="appEnviroment" placeholder="请输入内容"></el-input>
            </div>
        </div>
        <!-- 添加标签 -->
        <div class="app-info-item clearfix tag">
            <div class="item-title fl add-tag">添加标签：</div>
            <div class="item-content tag-list fl">
                <span class="tag-item" @click="onTagClicked(item)" :class="{'tag-item-sel': item.status}" v-for="item,index in tagList" :key="index">{{ item.name }}</span>
            </div>
        </div>
        <!-- 应用介绍 -->
        <div class="app-info-item">
            <div class="item-title fl">应用介绍：</div>
            <div class="item-content app-introduce">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="appIntroduce">
                </el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onCancelClicked" size="small">取 消</el-button>
            <el-button type="primary" @click="onSubmitClicked" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { SET_APP_INFO, SET_APP_SHARE, SET_APP_CHOOSE } from '@/http/api.js'
import CloudUpload from '@/components/setting/DeviceManagement/CloudUpload';
import SdkVersion2RuntimeEnv from './ApkSDKVersionInfo';
const AppInfoParser = require('app-info-parser')
export default {
    props: ['config','isEditApp'],
    data() {
        return {
            loading:false,
            //isEditApp:false,           //是否是二次编辑应用信息
            file: null,
            resName: "",               // 资源名称
            appId: 0,                  // 新建为0
            appIcon: "",               // 应用图标
            appName: "",               // 应用名称
            appVersion: "",            // 应用版本
            appEnviroment: "",         // 应用环境
            appIntroduce: "",          // 应用介绍
            appPackageName: "",        // 包名
            appLaunchableActivity:"",  
            appUploadConfig: {
                uploadDirect: false,
            },
            appIconUploadConfig: {
                uploadDirect: false,
            },
            tagList: [
                { name: '教学应用', status: false },
                { name: '学习应用', status: false },
                { name: '评价应用', status: false },
                { name: '研训应用', status: false },
                { name: '管理应用', status: false },
                { name: '其他应用', status: false }
            ],
            currentAppInfo:{}          // 二次编辑的时候当前应用的信息
        }
    },
    components: {
        CloudUpload,
    },
    computed: {
        // isEditApp(){
        //     return this.config.appInfo
        // }
    },
    watch: {
        config: {
            handler(newVal){
                if(newVal.dialogVisible){
                    // 新建状态
                    if(newVal.file && this.isEditApp == false){
                        this.file = newVal.file
                        this.appIntroduce = ""
                        this.initParserInfo()
                    }
                    // 编辑状态 传过来的 appInfo
                    if(newVal.appInfo && this.isEditApp == true){
                        // console.log("当前应用信息",newVal.appInfo)
                        // this.isEditApp = true
                        let info = newVal.appInfo
                        this.currentAppInfo = info    // 保存一下当前app的信息

                        this.appId = info.AAIdx
                        this.resName = info.AppName
                        this.appIcon = info.PreviewUrl
                        this.appName = info.APKRealName
                        this.appSize = info.Size
                        this.appPackageName = info.PackageName
                        this.appVersion = info.Verison
                        this.appEnviroment = info.Environment
                        this.appVersionCode = info.VerisonCode
                        this.appIntroduce = info.Comment
                        this.appLaunchableActivity = info.Activity

                        // this.appLaunchableActivity = info.LaunchableActivity
                        // this.appId = newVal.appInfo.appId
                        // this.resName = info.ApplicationLabel
                        // this.appIcon = info.AppIconPath
                        // this.appName = fileName
                        // this.appSize = this.getFileSizeString(this.file)
                        // this.appPackageName = info.PackageName
                        // this.appVersion = info.VersionName
                        // this.appEnviroment = info.MinAndroidVersion
                        // this.appVersionCode = info.VersionCode
                        // this.appLaunchableActivity = info.LaunchableActivity

                        this.tagList.forEach((item)=>{   // 重置标签
                            item.status = false
                        })

                        info.aatList.forEach((itemOut)=>{   // 根据接口返回值添加标签
                            this.tagList.forEach((itemIn)=>{
                                if(itemOut.AATName == itemIn.name){
                                    itemIn.status = true
                                }
                            })
                        })

                        // 默认选中第一个tag
                        // this.tagList.forEach((item,index)=>{
                        //     index != 0 ? item.status = false : item.status = true
                        // })
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 点击 tag
        onTagClicked(tag){
            tag.status = !tag.status
        },
        // apk 文件重新选择
        beforeApkFileSelected(file){
            this.file = file
            this.initParserInfo()
        },
        // 获取文件大小
        getFileSizeString(file){
            var fileSize = null;
            if (file.size > 1024 * 1024) {
                fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
            } else {
                fileSize = (Math.round(file.size * 100 / 1024) / 100).toString() + 'KB';
            }

            return fileSize;
        },
        // apk 图片重新选择
        beforeApkIconSelected(file){
            const reader = new FileReader()
            reader.readAsDataURL(file);
            reader.onload = (result) => {
                this.appIcon = result.target.result
            }
        },
        initParserInfo(){
            var fileName = this.file.name;
            var ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
            if (ext == "apk") {
                const parser = new AppInfoParser(this.file)
                parser.parse().then(result => {
                    //console.log('app info ----> ', result)
                    let application = result.application
                    let info = {
                        AppIconPath: result.icon,
                        ApplicationIcon: "",
                        ApplicationLabel: this.isValidArray(application.label) ? application.label[0] : "",
                        LaunchableActivity: this.isValidArray(application.activities) ? application.activities[0].name : "",
                        MinAndroidVersion: SdkVersion2RuntimeEnv[result.usesSdk.minSdkVersion], 
                        PackageName: result.package,
                        SdkVersion: result.usesSdk.minSdkVersion,
                        TargetSdkVersion: result.usesSdk.targetSdkVersion,
                        VersionCode: result.versionCode,
                        VersionName: result.versionName
                    }
                    this.resName = info.ApplicationLabel
                    this.appIcon = info.AppIconPath
                    this.appName = fileName
                    this.appSize = this.getFileSizeString(this.file)
                    this.appPackageName = info.PackageName
                    this.appVersion = info.VersionName
                    this.appEnviroment = info.MinAndroidVersion
                    this.appVersionCode = info.VersionCode
                    this.appLaunchableActivity = info.LaunchableActivity

                    // 默认选中第一个tag
                    this.tagList.forEach((item,index)=>{
                        index != 0 ? item.status = false : item.status = true
                    })
                }).catch(err => {
                    console.log('err ----> ', err)
                })
            } else {
                this.$message.error('文件格式不正确')
            }
        },
        handleClose(){
            this.$emit("onCancelClicked")
        },
        onCancelClicked(){
            this.$emit("onCancelClicked")
        },
        convertBase64UrlToBlob(base64) {
            var arr = base64.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            let blob = new Blob([u8arr], { type: mime });
            var fileName = this.getDateFileNameString() + "_" + this.loadAccount().userid + "_" + this.resName + "_preview.png";
            blob.name = fileName;
            return blob
        },
        getDateFileNameString() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }

            return year + "_" + month + "_" + day;
        },
        fileUploadProgress(info){
            //console.log(info)
        },
        // 保存app
        async onSubmitClicked(){
            if(this.appIcon == ""){
                this.$message.error('请添加资源图片')
                return false
            }
            if(this.resName == "" || 
               this.appName == "" || 
               this.appVersion == "" || 
               this.appEnviroment == ""){
                this.$message.error('请将信息补充完整')
                return false
            }
            if(!this.tagList.find(item=>{ return item.status == true })){
                this.$message.error('请至少选择一个应用标签')
                return false
            }
            if(this.appIntroduce == ""){
                this.$message.error('请填写应用描述')
                return false
            }
            
            let typeList = []
            this.tagList.forEach(item=>{ 
                if(item.status == true){
                    typeList.push(item.name)
                }
            })
            var param = {
                'session': this.getSession(),
                'aaIdx': this.appId,
                'appName': this.resName,
                'size': this.appSize,
                'verison': this.appVersion,
                'environment': this.appEnviroment,
                'fileUrl': "",
                'previewurl': "",
                'productpicture': "",
                'typeList': typeList.join("|"), //应用标签
                'comment': this.appIntroduce,
                'isDone': true,
                'packageName': this.appPackageName,
                'realName': this.appName,
                'verisonCode': this.appVersionCode,
                'activity': this.appLaunchableActivity,
                'objectIdList': JSON.stringify([0]),
                'pIdx': 2,
                'facilitator': "",
                'page':0
            }

            if(this.isEditApp == false){   // 本地上传
                // 上传封面图片
                var blob = this.convertBase64UrlToBlob(this.appIcon);
                await this.$refs.appIcon.simplifyUpload(blob, null, (info)=>{
                    param.previewurl = info.url
                    this.saveAppInfo(param)
                    // this.saveAppIcon(param)
                })
                // 上传 apk
                this.$refs.appFile.simplifyUpload(this.file, this.fileUploadProgress, (info)=>{
                    param.fileUrl = info.url
                    this.saveAppInfo(param)
                })
            }else{  // 二次编辑
                param.previewurl = this.currentAppInfo.PreviewUrl   // 照片的地址
                param.fileUrl = this.currentAppInfo.FileURL         // 当前文件的地址
                // console.log("二次编辑保存参数",param)
                this.saveAppInfo(param)    // 只调setAppInfo一个接口
            }
            
        },
        saveAppInfo(param){
            // console.log("应用信息",param)
            if(param.previewurl && param.fileUrl){  // 只有当头像和app都已经存到了腾讯云之后才会调接口保存这些信息
                if(this.isEditApp){    // 如果是二次编辑
                    SET_APP_INFO(this.$qs.stringify(param)).then((response)=>{
                        let result = response.data.result[0]
                        // console.log("保存成功了",response)
                        if(response.data.ReturnCode == 1){
                            this.$emit("onCancelClicked")   // 添加成功时关闭弹窗
                            this.$message({
                            message: '添加成功',
                            type: 'success'
                            });
                        }else{
                            this.$message.error('应用添加失败，请稍后再试')
                        }
                    })
                }else{            // 第一次本地上传
                    // 1 SetAttachmentApps 参数为传递过来的参数
                    // this.loading = true
                    SET_APP_INFO(this.$qs.stringify(param)).then((response)=>{
                        let result = response.data.result[0]
                        // console.log("保存成功了",response)
                        if(response.data.ReturnCode == 1){
                            // 2 对app设置共享
                            var shareParam = {
                                'session': this.getSession(),
                                'aaIdx': result.Idx,
                                'share': "未共享",
                                'isDone': true
                            };
                            // console.log("分享的参数",shareParam)

                            // 3 将应用加入班级
                            SET_APP_SHARE(this.$qs.stringify(shareParam)).then((response)=>{
                                if(response.data.ReturnCode == 1){  // 共享成功了
                                    var chooseParam = {
                                        'aaIdx': result.Idx,
                                        'page': 1,
                                        'session': this.getSession(),
                                        'schoolidx':this.loadAccount().schoolidx,
                                        'classidx':0,
                                        'gradeidx':0,
                                        'periodidx':0
                                    }
                                    // console.log("加入班级的参数",chooseParam)
                                    SET_APP_CHOOSE(this.$qs.stringify(chooseParam)).then((response)=>{
                                        if(response.data.ReturnCode == 1){
                                            // this.loading = false
                                            this.$emit("onCancelClicked")   // 添加成功时关闭弹窗
                                            this.$message({
                                            message: '添加成功',
                                            type: 'success'
                                            });
                                            this.$emit("submitSucc")    // 刷新应用列表
                                        }else{
                                            this.$message.error('加入班级失败，请联系管理员');
                                        }
                                    })
                                }else{
                                    this.$message.error('共享范围设置失败，请联系管理员')
                                }
                            })
                        }else{
                            this.$message.error('应用添加失败，请稍后再试')
                        }
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/account-setting.scss';   // 颜色统一定义
::v-deep .el-dialog__header{   // 弹窗title区域
    border-bottom: 1px solid #ebebeb;
    padding: 16px;
    font-weight: 600;
}
::v-deep .el-dialog__body{   // 弹窗title区域
    padding: 0px 20px;
}
::v-deep .el-dialog__footer{   // 弹窗title区域
    border-top: 1px solid #ebebeb;
}
.fl{
    float: left;
}
.clearfix:after{
    content: "";
    display: block;
    height: 0;
    visibility: hidden;  
    clear: both;
}
.app-info-item{
    margin-bottom: 24px;
    .item-title{
        display: inline-block;
        margin-right: 10px;
    }
    .item-content{
        display: inline-block;
        ::v-deep .el-input{
            width: 336px;
            height: 38px;
        }
    }
    .app-introduce{
        width: calc(100% - 82px);
    }
    .add-tag{  // 添加标签
        margin-bottom: 15px;
        line-height: 24px;
    }
    .tag-list{
        width: 336px;
        position: relative;
        // top: -5px;
        .tag-item{
            width: 72px;
            text-align: center;
            color: #000;
            display: inline-block;
            height: 24px;
            line-height: 24px;
            border: 1px solid transparent;
            box-sizing: border-box;
            margin-bottom: 5px;
            cursor: pointer;
        }
        .tag-item:not(:nth-child(4n)){
            margin-right: 16px;
        }
        .tag-item-sel{
            color: #FF7513;
            border: 1px solid #FF7513;
            background: rgba(255,117,19,0.04);;
        }
    }
    .edit-status{
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .edit-title{
            margin-right: 10px;
            line-height: 46px;
        }
        .app-icon{
            top: 0;
        }
        img{
            cursor: default;
        }
    }
}
.app-info-item:nth-child(1){
    margin-top: 24px;
}
.app-info-item.reselect-appicon{
    margin-top: 24px;
    margin-bottom: 10px;
}
.app-info-item.tag{
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
}
.local-add {
    width: 110px;
    line-height: 28px;
    height: 28px;
    ::v-deep .el-upload--picture-card{
        border: none;
        background-color: initial;
    }
    ::v-deep .el-upload--picture-card:hover{
        border-color: initial;
        color: initial;
    }
    .local-add-slot{
        display: flex;
        align-items: center;
        width: 108px;
        height: 28px;
        line-height: 28px;
        position: relative;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0 8px;
        font-size: 12px;
        img{
            width: 14px;
            height: 14px;
            margin-right: 5px;
            vertical-align: initial;
        }
    }
}
.app-icon{
    width: 46px;
    height: 46px;
    border-radius: 50%;
    border: none;
    position: relative;
    top: -10px;
    cursor: pointer;
    ::v-deep .app-icon-wrap{
        position: relative;
    }
    ::v-deep .app-icon-wrap .app-icon-refresh{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        background-image: url("/Account/images/setting/navigation/device-management/icon_avatar_refresh.png");
        background-size: 24px;
        background-repeat: no-repeat;
        background-position: center;
        display: none;
        border-radius: 50%;
    }
    ::v-deep .app-icon-wrap:hover .app-icon-refresh{
        display: block;
    }
    ::v-deep img{
        display: block;
        border-radius: 50%;
        width: 46px;
        height: 46px;
        object-fit: contain;
    }
    ::v-deep span{
        width: 130px;
        display: block;
        color: #969696;
        height: 46px;
        line-height: 46px;
        text-align: left;
    }
}
</style>